import script from "./BoxTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxTab.vue?vue&type=script&setup=true&lang=js"

import "./BoxTab.vue?vue&type=style&index=0&id=8bde1266&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bde1266"]])

export default __exports__